
import { Element } from "@craftjs/core"
import { Tabs } from "twyne-new.ui";

import BasePreview from "@/components/builder/blocks/base"
import { define, prop } from "@/components/builder/utils"

import { FormFieldWrapperBlock, FormRowBlock, FormColBlock, StepBlock, FormContinueButtonBlock } from "..";
import { useTailwindConfig } from "../../utils/tailwindConfig/hooks";

import { useFormContainer } from "./context";

function FormContainerPreview({ ...props }) {
  const { form, step, formId } = useFormContainer()

  useTailwindConfig('utilities', DEFAULT_FORM_UTILITIES)

  const { definition } = form || {}

  if (!definition) {
    return <div>Loading...</div>
  }

  return <BasePreview {...props}>
    <form>
      <Tabs value={step} key={formId}>
        {form.definition.map((step, idx) => <Element key={idx} is={StepBlock} id={`step-${idx}-${formId}`} step={idx + 1}>
          {step.map((row, idx) => <Element key={idx} is={FormRowBlock} id={`grid-${idx}-${formId}`} columns={row.cols.length}>
            {row.cols.map((col, idx) => <Element is={FormColBlock} id={`col-${idx}-${formId}`} key={idx} col={col.size}>
              <Element is={FormFieldWrapperBlock} id={`field-${idx}-${formId}`} field={col} />
            </Element>)}
          </Element>)}
          {!form.custom_continue && <Element is={FormContinueButtonBlock} id={`continue-button-${formId}`} label={form.submit_label} />}
        </Element>)}
      </Tabs>
    </form>
  </BasePreview>
}

function FormContainerHTML({ submitText }) {
  return <div className="builder-form-container">
    {`{{> forms/form-container${submitText ? ` submitText="${submitText}"` : ''}}}`}
    {'<!-- ** -->'}
    {'{{> forms_extra/checkers}}'}
    <script type="text/javascript" dangerouslySetInnerHTML={{
      __html: `
        document.addEventListener("DOMContentLoaded", function(){

          var updateFormProgress = function(current, total){
            var progress = {
              step: parseInt(current) || 0,
              total: parseInt(total) || 0,
            }

            document.dispatchEvent(new CustomEvent('update-progress-bar', { detail: { progress } }))
            localStorage.setItem("progress", JSON.stringify(progress))
          }

          Lander.onStepChange(updateFormProgress)

          var steps = document.querySelectorAll(".pe-builder-form-step")
          updateFormProgress(1, steps && steps.length)
        })
      `,
    }} />
  </div>
}

export const DEFAULT_FORM_UTILITIES = {
  '.hidden': 'hidden',
  '.pe-builder-grid-row': 'flex flex-row gap-2',
  '.pe-builder-grid-col': 'flex-1',
  '.pe-builder-grid-col-3': 'basis-3/12',
  '.pe-builder-grid-col-4': 'basis-4/12',
  '.pe-builder-grid-col-5': 'basis-5/12',
  '.pe-builder-grid-col-6': 'basis-6/12',
  '.pe-builder-grid-col-7': 'basis-7/12',
  '.pe-builder-grid-col-8': 'basis-8/12',
  '.pe-builder-grid-col-9': 'basis-9/12',
  '.pe-builder-grid-col-10': 'basis-10/12',
  '.pe-builder-grid-col-11': 'basis-11/12',
  '.pe-builder-grid-col-12': 'basis-12/12',
  '.pe-builder-grid-cols-1': 'grid-cols-1',
  '.pe-builder-grid-cols-2': 'grid-cols-2',
  '.pe-builder-grid-cols-3': 'grid-cols-3',
  '.pe-builder-grid-cols-4': 'grid-cols-4',
  '.pe-builder-grid-cols-5': 'grid-cols-5',
  '.pe-builder-grid-cols-6': 'grid-cols-6',
  '.pe-builder-grid-cols-7': 'grid-cols-7',
  '.pe-builder-grid-cols-8': 'grid-cols-8',
  '.pe-builder-grid-cols-9': 'grid-cols-9',
  '.pe-builder-grid-cols-10': 'grid-cols-10',
  '.pe-builder-grid-cols-11': 'grid-cols-11',
  '.pe-builder-grid-cols-12': 'grid-cols-12',
  '.pe-builder-hidden': 'hidden!',
}

export default define('form-container', FormContainerPreview, FormContainerHTML)
  .shared(prop.share('form-container', 'form-container'))
  .property(prop.text('Submit Text', 'submitText').category('default').own())
  .build()
